import React from 'react';
import twitchLogo from './images/twitchLogo.png';
import tiktokLogo from './images/tiktokLogo.png';
import youtubeLogo from './images/youtubeLogo.png';
import instagramLogo from './images/instagramLogo.png';
import twitterLogo from './images/twitterLogo.png';
import costvLogo from './images/costvLogo.png';
import discordLogo from './images/discordLogo.png';
import facebookLogo from './images/facebookLogo.png';
import naruxforallLogo from './images/naruxforallLogo.png';
import naruxforpokeLogo from './images/naruxforpokeLogo.png';

const Redes = () => (

    <div className='page redes'>
        <div className='card zoom'>
            <a href='https://www.youtube.com/@naruxforall'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' decoding='async'></img>
                <img src={youtubeLogo} alt='YouTube' width='2560' height='1076' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.youtube.com/@NaruxForPoke'>
                <img className='brand-logo' src={naruxforpokeLogo} alt='NaruxForPoke' width='300' height='300' decoding='async'></img>
                <img src={youtubeLogo} alt='YouTube' width='2560' height='1076' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.instagram.com/naruxforall/?hl=es'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={instagramLogo} alt='Instagram' width='1000' height='260' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.instagram.com/naruxforpoke/'>
                <img className='brand-logo' src={naruxforpokeLogo} alt='NaruxForPoke' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={instagramLogo} alt='Instagram' width='1000' height='260' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.twitch.tv/naruxforall'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={twitchLogo} alt='Twitch' width='569' height='181' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://discord.gg/rQAkM3q'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={discordLogo} alt='Discord' width='3840' height='1096' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.tiktok.com/@naruxforolo?lang=es'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={tiktokLogo} alt='TikTok' width='1210' height='360' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.tiktok.com/@naruxforpoke'>
                <img className='brand-logo' src={naruxforpokeLogo} alt='NaruxForPoke' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={tiktokLogo} alt='TikTok' width='1210' height='360' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://twitter.com/AllNarux'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={twitterLogo} alt='Twitter' width='1000' height='260' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://cos.tv/channel/32540282384197632'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={costvLogo} alt='COS.TV' width='1384' height='310' loading='lazy' decoding='async'></img>
            </a>
        </div>
        <div className='card zoom'>
            <a href='https://www.facebook.com/profile.php?id=100090619517444'>
                <img className='brand-logo' src={naruxforallLogo} alt='NaruxForAll' width='300' height='300' loading='lazy' decoding='async'></img>
                <img src={facebookLogo} alt='Facebook' width='4800' height='904' loading='lazy' decoding='async'></img>
            </a>
        </div>
    </div>

)

export default Redes
